import { RoyaltySplitPriorityPayee } from './royalty-split-priority-payee.interface';

export interface RoyaltySplitCreateRequest {
  name: string;
  includedRevenue: string[];
  expirationDate: string;
  payees: RoyaltySplitCreatePayee[];
  priorityPayees: RoyaltySplitPriorityPayee[];
  dspsToInclude: number[];
  dspsToExclude: number[];
  countriesToInclude: number[];
  countriesToExclude: number[];
  releaseIds: number[];
  trackIds: number[];
}

export interface RoyaltySplitCreatePayee {
  payeeId: number;
  artistId: number;
  sharePercentage: number;
  artistTypeId: number;
  languageId: number;
}

export function createEmptyRoyaltySplitForm(): RoyaltySplitCreateRequest {
  return {
    name: '',
    includedRevenue: [],
    expirationDate: '',
    payees: [],
    priorityPayees: [],
    dspsToInclude: [],
    dspsToExclude: [],
    countriesToInclude: [],
    countriesToExclude: [],
    releaseIds: [],
    trackIds: [],
  };
}
